import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  Checkbox,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import { includes, pluck } from "ramda";
import clsx from "clsx";

const statuses = [
  { display: "None", value: "(-status:* AND *:*)" },
  { display: "Approved", value: "APPROVED" },
  { display: "Deleted", value: "DELETED" },
  { display: "Rejected", value: "REJECTED" },
  { display: "Pending", value: "PENDING" },
  { display: "Takedown", value: "TAKEDOWN" },
];

const useStyles = makeStyles(theme => ({
  container: {
    paddingRight: 30,
    paddingLeft: 30,
  },

  none: {
    fontStyle: "italic",
  },
}));

const ContentFacetMediaStatus = ({ facet, handleClick }) => {
  const classes = useStyles();
  const terms = pluck("code", facet.selectedTerms);

  return (
    <List>
      {statuses.map(status => (
        <ListItem key={status.display} className={classes.container}>
          <ListItemText
            className={clsx({ [classes.none]: status.display === "None" })}
          >
            {status.display}
          </ListItemText>
          <ListItemSecondaryAction>
            <Checkbox
              color="primary"
              value={status.value}
              checked={includes(status.value, terms)}
              onChange={handleClick(status.value)}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default ContentFacetMediaStatus;
